import { t } from "i18next";

import Close from "@/assets/icons/close.svg?react";
import Check from "@/assets/icons/mark.svg?react";

import styles from "./styles";
import { ILevelSuccess } from "../../interfaces";

export const LevelSuccess = ({ title = t("Levels.Completed"), status = "completed" }: ILevelSuccess) => {
  return (
    <styles.Container $isPending={status === "pending"}>
      {status === "completed" ? <Check /> : <Close />}
      {title}
    </styles.Container>
  );
};
